/**
 * Data layer for `openapi-spec-sdks-node-python-go-php-ruby`. Thin typed fetch wrappers over /api/v1/openapi-spec-sdks-node-python-go-php-ruby.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface OpenapiSpecSdksNodePythonGoPhpRubyRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListOpenapiSpecSdksNodePythonGoPhpRubyResponse {
	count: number;
	items: OpenapiSpecSdksNodePythonGoPhpRubyRow[];
}

export interface CreateOpenapiSpecSdksNodePythonGoPhpRubyBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/openapi-spec-sdks-node-python-go-php-ruby";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListOpenapiSpecSdksNodePythonGoPhpRubyResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListOpenapiSpecSdksNodePythonGoPhpRubyResponse>(res);
}

export async function create(body: CreateOpenapiSpecSdksNodePythonGoPhpRubyBody): Promise<OpenapiSpecSdksNodePythonGoPhpRubyRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<OpenapiSpecSdksNodePythonGoPhpRubyRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const openapiSpecSdksNodePythonGoPhpRubyQueryKeys = {
	all: ["openapi-spec-sdks-node-python-go-php-ruby"] as const,
	list: () => [...openapiSpecSdksNodePythonGoPhpRubyQueryKeys.all] as const,
	detail: (id: string) => [...openapiSpecSdksNodePythonGoPhpRubyQueryKeys.all, id] as const,
};
